import { Facebook, Instagram, Rss, Twitter } from 'lucide-react';
import { useCategories } from '@/hooks/use-categories';
import { useCategory } from '@/contexts/CategoryContext';
import { Link } from 'react-router-dom';

export const AppFooter = () => {
  const { categories, isLoading } = useCategories();
  const { setSelectedCategoryId, setSelectedCategoryName } = useCategory();

  // Get first 5 categories
  const displayCategories = categories.slice(0, 5);

  const handleCategoryClick = (categoryId: string, categoryName: string) => {
    setSelectedCategoryId(categoryId);
    setSelectedCategoryName(categoryName);
  };

  return (
    <footer className="bg-[#1a1a1a] text-white py-12 mt-16">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-8 mb-8">
          {/* Logo Section - Full width (2 columns) on mobile */}
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center mb-4">
              <a href="/" className="flex items-center">
                <img 
                  src="/logoFinal.svg" 
                  alt="Indispare Logo" 
                  className="h-10 w-auto brightness-0 invert"
                />
              </a>
            </div>
            <p className="text-sm text-gray-400 mb-4">
              Largest search based Industrial spare parts marketplace across India
            </p>
            <div className="flex gap-3">
              <a href="#" className="bg-primary hover:bg-primary/80 p-2 rounded">
                <Facebook className="h-4 w-4" />
              </a>
              <a href="#" className="bg-primary hover:bg-primary/80 p-2 rounded">
                <Twitter className="h-4 w-4" />
              </a>
              <a href="#" className="bg-primary hover:bg-primary/80 p-2 rounded">
                <Rss className="h-4 w-4" />
              </a>
              <a href="#" className="bg-primary hover:bg-primary/80 p-2 rounded">
                <Instagram className="h-4 w-4" />
              </a>
            </div>
          </div>

          {/* Quick Links - Side by side with Categories on mobile */}
          <div>
            <h4 className="font-semibold mb-4 text-sm md:text-base">Quick Links</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="#" className="hover:text-white transition-colors">Home</a></li>
              <li><a href="#" className="hover:text-white transition-colors">About Us</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Services</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Contact</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Blog</a></li>
            </ul>
          </div>

          {/* Categories - Side by side with Quick Links on mobile */}
          <div>
            <h4 className="font-semibold mb-4 text-sm md:text-base">Categories</h4>
            {isLoading ? (
              <ul className="space-y-2 text-sm text-gray-400">
                <li>Loading...</li>
              </ul>
            ) : displayCategories.length > 0 ? (
              <ul className="space-y-2 text-sm text-gray-400">
                {displayCategories.map((category) => (
                  <li key={category.id}>
                    <Link
                      to="/"
                      onClick={() => handleCategoryClick(String(category.id), category.name)}
                      className="hover:text-white transition-colors"
                    >
                      {category.name}
                    </Link>
                  </li>
                ))}
              </ul>
            ) : (
              <ul className="space-y-2 text-sm text-gray-400">
                <li>No categories available</li>
              </ul>
            )}
          </div>
        </div>

        <div className="border-t border-gray-800 pt-6 text-center text-sm text-gray-400">
          © 2025 Indispare Quick Delivery. All Rights Reserved
        </div>
      </div>
    </footer>
  );
};
